<template>
    <div>
        <div v-for="pInfo in pagedInfos" style="clear:both;">
            <paged-infos :init-filter="pInfo"></paged-infos>
        </div>
    </div>
</template>
<script>
    import PagedInfos from '../components/PagedInfos.vue';
    import Slider from '../components/slider/Slider.vue';
    export default {
        components: {
            PagedInfos: PagedInfos,
            Slider: Slider
        },
        props: {
            "configs": Object,
            "filterInfo": Object,
            "sliderData": { type: Array, default: null }
        },
        computed: {
            pagedInfos: function () {
                var arr = this.configs.pagedInfos.index;
                return arr;
            }
        },
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>